import { Group } from "@mantine/core"
import { useMemo } from "react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { HorizontalDivider } from "~/pages/Brand/Products/Details/TraceabilityGraph/Divider.tsx"
import { SupplierCard } from "~/pages/Brand/Products/Details/TraceabilityGraph/SupplierCard.tsx"

type Props = {
  activityName: string
  item?: LibraryResponses.EnrichedItem
  hideFirstDivider?: boolean
}

export const TraceabilityTreeBranch = ({
  activityName,
  item,
  hideFirstDivider = false,
}: Props) => {
  const operation = useMemo(
    () => item?.operations?.find((op) => op.activityName === activityName),
    [activityName, item?.operations]
  )
  return (
    <Group key={activityName} gap={0} align="flex-start" wrap="nowrap">
      {!hideFirstDivider && <HorizontalDivider />}
      <SupplierCard
        activityName={activityName}
        itemReference={item?.reference}
        operation={operation}
      />
    </Group>
  )
}
